import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  myPlansDocuments: {
    document_name: string;
    document_url: string;
  }[];
  myPlansMessage: string;
  errorMessage: string;
  error: boolean;
  loading: boolean;
} = {
  myPlansDocuments: [],
  myPlansMessage: "",
  error: false,
  loading: false,
  errorMessage: "",
};
const fetchMyPlansDocuments = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_MYPLANS_DOCUMENTS_SUCCESS: {
      console.log("action.myPlansDocuments", action.myPlansDocuments);
      return updateObject(state, {
        myPlansDocuments: action.myPlansDocuments,
        error: false,
        loading: false,
        errorMessage: "",
        myPlansMessage: "",
      });
    }
    case actionTypes.FETCH_MYPLANS_DOCUMENTS_SUCCESS_NO_LIST: {
      console.log("action.myPlansDocuments", action.myPlansMessage);
      return updateObject(state, {
        myPlansDocuments: initialState.myPlansDocuments,
        error: false,
        loading: false,
        errorMessage: "",
        myPlansMessage: action.myPlansMessage,
      });
    }
    case actionTypes.FETCH_MYPLANS_DOCUMENTS_STARTED:
      return updateObject(state, {
        myPlansDocuments: initialState.myPlansDocuments,
        error: false,
        loading: true,
        errorMessage: "",
        myPlansMessage: "",
      });

    case actionTypes.FETCH_MYPLANS_DOCUMENTS_FAILED:
      return updateObject(state, {
        myPlansDocuments: initialState.myPlansDocuments,
        error: true,
        loading: false,
        errorMessage: action.errorMessage,
        myPlansMessage: "",
      });

    case actionTypes.RESET_MYPLANS_DOCUMENTS_STARTED:
      return updateObject(state, {
        myPlansDocuments: initialState.myPlansDocuments,
        error: false,
        loading: false,
        errorMessage: "",
        myPlansMessage: "",
      });

    default:
      return state;
  }
};

export default fetchMyPlansDocuments;
